(function(app) {
    app.constant("emailAddressTypes",
    [
        "Personal",
        "Business",
        "Other"
    ]);
})(window.app); //jshint ignore:line